import * as React from "react";
import { useHistory } from "react-router-dom";

// Components
import Container from "../components/Container/Container";
import Button from "../components/Button/Button";

// Misc.
import { useBaseState } from "../context/Base.context";
import requestAndDownloadBundle from "../lib/ProgressBundle.lib";

const SavePage: React.FC = () => {
  const baseState = useBaseState();
  const history = useHistory();

  return (
    <Container>
      <div className="w-11/12 xxl:w-full mx-auto">
        <h1 className="text-dw-blue text-xl sm:text-2xl md:text-3xl font-semibold font-serif">
          Save Progress
        </h1>
        <p className="text-dw-grey-13 font-bold mt-3 md:text-18">
          You can download a file ending with „.threatcheck“. You can upload
          this file again later under „Continue Policy“ and all your answers
          will appear again in the tool.
        </p>
        <div className="sm:flex sm:mt-3">
          <Button
            type="button"
            buttonType="secondary"
            className="my-3 sm:my-0 sm:w-auto sm:ml-auto sm:mr-0"
            onClick={() => {
              history.goBack();
            }}
          >
            Back
          </Button>
          <Button
            type="button"
            className="sm:w-auto sm:ml-3"
            onClick={() => {
              requestAndDownloadBundle(baseState);
            }}
          >
            Download
          </Button>
        </div>
      </div>
    </Container>
  );
};

export default SavePage;
